import type { AccuracyErrorItem } from '../types/accuracy';
import type { GuidelineChatProposal } from '../types/guidelineProposal';
import type { MetricCountDrilldown } from './accuracyCountDrilldown';
import { DRILLDOWN_LABELS } from './accuracyCountDrilldown';
import { buildGuidelineChatProposal } from './accuracyGuidelineProposals';

export interface AccuracyChatMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  proposal?: GuidelineChatProposal;
  createdAt: string;
}

export interface AccuracyGuidelineChatContext {
  reportId: string;
  reportName?: string;
  guidelineVersion: number;
  drilldown: MetricCountDrilldown;
  totalItemCount: number;
  urlCount: number;
  sampleErrors: AccuracyErrorItem[];
  /** e.g. ベースライン監査 / チューニング #2 */
  errorSourceLabel?: string;
}

const SUGGESTED_PROMPTS = [
  '誤検知を減らすためのガイドライン修正案を提案してください',
  '検知漏れを減らすためのガイドライン修正案を提案してください',
  '検出条件を厳しくしすぎている可能性はありますか？',
  'このカテゴリ向けのチェック項目の見直し案を出してください',
];

export function getSuggestedPrompts(): string[] {
  return [...SUGGESTED_PROMPTS];
}

/** Simulates LLM chat (replace with API when backend is ready). */
export async function sendAccuracyGuidelineChatMessage(
  ctx: AccuracyGuidelineChatContext,
  _history: AccuracyChatMessage[],
  userMessage: string
): Promise<GuidelineChatProposal> {
  const trimmed = userMessage.trim();
  if (!trimmed) {
    throw new Error('メッセージを入力してください');
  }

  await new Promise((r) => setTimeout(r, 800 + Math.random() * 700));

  const proposal = buildGuidelineChatProposal(ctx, trimmed);

  if (proposal.hunks.length > 0) {
    const metric = DRILLDOWN_LABELS.metricType[ctx.drilldown.metricType];
    proposal.summary = `${proposal.summary}\n\n対象フィールド: ${metric === '存在フラグ' ? 'existence_check_prompt' : 'violation_check_prompt'} ほか（下記 diff 参照）。`;
  }

  return proposal;
}
